import { useMemo, useState } from 'react'
import cn from 'classnames'
import { ContentSteps, useStepFlow } from 'src/lib/useStepFlow'
import { FirstStep, SecondStep } from './ui/steps'
import Logo from '../../icons/logo.webp'
import LeftCloud from '../../icons/left-cloud.webp'
import RightCloud from '../../icons/right-cloud.webp'
import Gorka from '../../icons/gorka.webp'
import Pots from '../../icons/pots.webp'
import LightUnderPots from '../../icons/light-under-pots.webp'
import Turtle from '../../icons/turtle.webp'
import Pot from '../../icons/pot.webp'
import Frog from '../../icons/frog.webp'
import FrogLight from '../../icons/frog-light.webp'
import styles from './styles.module.scss'
import { Person } from './ui/person/Person'
import { normalizeBrowserLang, type TLang } from 'src/constants/langs'

const PlinkoLand = () => {
    const { step, goToNextStep } = useStepFlow()
    const [anime, setAnime] = useState(false)
    const [click, setClick] = useState(false)

    const currentLang = useMemo<TLang>(() => {
        const nav = typeof navigator !== 'undefined' ? navigator.language : 'en'
        return normalizeBrowserLang(nav)
    }, [])

    const onClick = () => {
        setClick(true)
    }
    const onMoveAnime = () => {
        setAnime(true)
    }

    return (
        <div className={styles.root}>
            <img src={Logo} alt="Logo" className={styles.logo} />
            <div className={styles.container}>
                {step === ContentSteps.SECOND && (
                    <SecondStep lang={currentLang} />
                )}
                <img src={Turtle} alt="Turtle" className={styles.turtle} />
                <img src={Pot} alt="Pot" className={styles.pot} />
                <div className={styles.wrapper_frog}>
                    <img
                        src={FrogLight}
                        alt="Frog-Ligft"
                        className={styles.frog_light}
                    />
                    <img src={Frog} alt="Frog" className={styles.frog} />
                </div>
                <div className={styles.gorka_wrapper}>
                    <img
                        src={LeftCloud}
                        alt="LeftCloud"
                        className={cn(styles.cloud, styles.left_cloud)}
                    />
                    <img
                        src={RightCloud}
                        alt="RightCloud"
                        className={cn(styles.cloud, styles.right_cloud)}
                    />
                    <img src={Gorka} alt="Gorka" className={styles.gorka} />
                    <img
                        src={LightUnderPots}
                        alt="LightUnderPots"
                        className={styles.light_under_pots}
                    />
                    <img src={Pots} alt="Pots" className={styles.pots} />
                    {anime && (
                        <img
                            src={'/images/coins.svg'}
                            alt="Anime"
                            className={styles.coins_anime}
                        />
                    )}
                    <Person position="left" />
                    <Person position="right" />
                    {!click && (
                        <FirstStep
                            onClick={onClick}
                            onAnime={onMoveAnime}
                            onNext={goToNextStep}
                            step={step}
                            lang={currentLang}
                        />
                    )}
                    <div className={styles.bg_footer} />
                </div>
            </div>
        </div>
    )
}
export default PlinkoLand
